<template>
  <nav id="footer">
    <div class="container">
      <div class="pull-left fnav">
        <p>
          Copyright &copy; {{ $t("home.copyright") }} | 鲁ICP备16041216号-4<a
            target="_blank"
            href=""
          ></a>
        </p>
      </div>
      <!--       <div class="pull-right fnav">
        <ul class="footer-social">
          <li>
            <a href="#"
              ><img src="@/assets/img/icon/wechat.svg" alt="微信" width="30px"
            /></a>
          </li>
          <li>
            <a href="#"
              ><img src="@/assets/img/icon/tiktok.svg" alt="微信" width="30px"
            /></a>
          </li>
          <li>
            <a href="#"
              ><img src="@/assets/img/icon/weibo.svg" alt="微信" width="30px"
            /></a>
          </li>
        </ul>
      </div> -->
    </div>
  </nav>
</template>

<script setup></script>

<style scoped>
#footer {
  margin-top: auto;
  width: 100%;
}
.footer-social li > a img {
  margin-right: 10px;
}
ul {
  margin: 0px;
}
</style>
